import React from 'react';
import { FilterOptionCheckbox } from '../filter-option-checkbox-group/filter-option-checkbox';
import getFormattedLabel from '@/catalog/utils/get-formatted-label';

interface FilterOptionSubCheckboxProps {
  /** The child filter value for this checkbox, e.g. `330i` */
  subFilter: string;
  subFilterCount?: number;
  /**  The main (or parent) filter value associated with this checkbox, e.g. `BMW` */
  mainFilter: string;
  /** Determines if the checkbox is checked. */
  checked: boolean;
  /** Function to toggle the state of the checkbox. */
  toggleSubCheckbox: (checked: boolean, mainValue: string, subValue: string) => void;
}

function FilterOptionSubCheckbox({
  mainFilter,
  subFilter,
  subFilterCount,
  checked,
  toggleSubCheckbox,
}: FilterOptionSubCheckboxProps) {
  const disabled = !checked && subFilterCount !== undefined && subFilterCount === 0;

  return (
    <FilterOptionCheckbox
      key={subFilter}
      checked={checked}
      label={getFormattedLabel(subFilter, subFilterCount, disabled)}
      value={subFilter}
      disabled={disabled}
      onClick={() => toggleSubCheckbox(checked, mainFilter, subFilter)}
    />
  );
}

// Note: Without this, all FilterOptionSubCheckbox of the same group re-render if another is toggled.
export default React.memo(FilterOptionSubCheckbox);
